'use strict';

wbApp.factory('protectedStorageSvc', ['$resource', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, notificationSvc, repositorySvc) {

        var ProtectedStorage = $resource('/restapi/protected-content/:id', {}, {            
            'getDirectory': { method: 'GET', isArray: true, url: '/restapi/protected-content' },
            'getDownloadUrl': { method: 'POST', url: '/restapi/protected-content/create-download-url' },
            'setPublicAccess': { method: 'POST', url: '/restapi/protected-content/set-public-access' },
            'getUploadUrl': { method: 'POST', url: '/restapi/protected-content/create-upload-url' },
            'createDirectory': { method: 'POST', url: '/restapi/protected-content/create-directory' },
            'deleteFile': { method: 'DELETE', url: '/restapi/protected-content/delete-file' },
            'deleteDirectory': { method: 'DELETE', url: '/restapi/protected-content/delete-directory' },
            'findGalleryInfoByPaths': { method: 'POST', isArray: true, url: '/restapi/protected-content/gallery/find-by-paths' },
            'updateGalleryInfo': { method: 'PUT', url: '/restapi/protected-content/gallery/:path' },
        });

        function getDirectory(path) {
            return repositorySvc.customGet('getDirectory', ProtectedStorage, { path: path });
        }
        
        function updateGalleryInfo(model, path) {
            return repositorySvc.customPutWithParams(
                'updateGalleryInfo',
                ProtectedStorage,
                {
                    path: path
                },
                model,
                null,
                null,
                false
            );
        }
        
        // paths: ["PhotoAlbum", "PhotoAlbum2"]
        // includeImages: true|false
        function findGalleryInfoByPaths(paths, includeImages) {
            return repositorySvc.customPostWithParams(
                'findGalleryInfoByPaths',
                ProtectedStorage,
                {},
                {
                    includeImages: !!includeImages,
                    paths: paths
                },
                null,
                null,
                true);
        }

        function getDownloadUrl(path) {
            return repositorySvc.customPostWithParams(
                'getDownloadUrl',
                ProtectedStorage,
                { objectUri: path },
                null,
                null,
                null,
                true);
        }

        function setPublicAccess(path, isPublic) {
            return repositorySvc.customPostWithParams(
                'setPublicAccess',
                ProtectedStorage,
                {
                    objectUri: path,
                    isPublic: isPublic
                },
                null,
                null,
                null,
                true);
        }

        function getUploadUrl(path, contentType) {
            return repositorySvc.customPost(
                'getUploadUrl',
                ProtectedStorage,
                {
                    objectUri: path,
                    contentType: contentType
                },
                null,
                null,
                true);
        }

        function createDirectory(path) {
            return repositorySvc.customPostWithParams(
                'createDirectory',
                ProtectedStorage,
                { objectUri: path },
                null,
                null,
                null,
                true);
        }

        function deleteFile(path) {
            return repositorySvc.customPostWithParams(
                'deleteFile',
                ProtectedStorage,
                { objectUri: path },
                null,
                null,
                null,
                true);
        }

        function deleteDirectory(path) {
            return repositorySvc.customPostWithParams(
                'deleteDirectory',
                ProtectedStorage,
                { objectUri: path },
                null,
                null,
                null,
                true);
        }

        return {
            getDirectory: getDirectory,
            getDownloadUrl: getDownloadUrl,
            setPublicAccess: setPublicAccess,
            getUploadUrl: getUploadUrl,
            createDirectory: createDirectory,
            deleteFile: deleteFile,
            deleteDirectory: deleteDirectory,
            findGalleryInfoByPaths: findGalleryInfoByPaths,
            updateGalleryInfo: updateGalleryInfo
        }
    }
]);
